module.exports = __webpack_public_path__ + "static/media/Q3.288833da.jpg";